import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { GeneralOrderComponent } from './general-order.component';
import { TranslateModule } from '../../../translate/translate.module';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule],
  declarations: [GeneralOrderComponent],
  exports: [GeneralOrderComponent]
})
export class GeneralOrderModule { }
